<div class="wrapper">
    <p [innerHTML]="contactdetails"></p>
</div>